module.exports = __webpack_public_path__ + "static/media/tyre-yellow-four3.f88ef2d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tyre-yellow-four3.png
// module id = 355
// module chunks = 0